module.exports = __webpack_public_path__ + "img/item13.5cd084a1.png";